<div>
  <form [formGroup]="formGroup">
      <kendo-grid [kendoGridBinding]="checklistItemList" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="enableChkLstItemFilter" [pageSize]="15" [pageable]="true" (edit)="editRowData($event)" (save)="UpdateRowData($event)" (cancel)="cancelRowData($event)" (add)="addHandler()">
          <ng-template kendoPagerTemplate>
              <div class="k-pager-left">
                  <kendo-pager-info></kendo-pager-info>
              </div>
              <div class="k-pager-right">
                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                  <kendo-pager-input></kendo-pager-input>
                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
              </div>
          </ng-template>
          <ng-template kendoGridToolbarTemplate>
              <div class="k-grid-toolbar-content d-flex">
                  <div class="flex-grow-1 title-container">
                      <p class="title">
                          Check list Items
                          <span *ngIf="checklistName">
                              for - {{checklistName}}
                          </span>
                      </p>
                      <div class="divider-container d-none d-md-block" id="imgDivider">
                          <span></span>
                      </div>
                      <button (click)="emit()" class="border-0 checklist-icon"><i class="fa fa-arrow-left fs-30 vertical-align-middle eip-mr-5" matTooltip="Back" aria-hidden="true"></i>Back</button>
                  </div>
                  <div class="flex-grow-1 mat-panel-headerbar"></div>
                  <div class="pagination-container">
                  </div>
                  <div class="pagination-container">
                      <p id="lblShowDetails">Show</p>
                      <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                      </kendo-pager-page-sizes>
                      <span>Items</span>
                  </div>
                  <div class="divider-container d-none d-md-block" id="imgDivider">
                      <span></span>
                  </div>
                  <div class="icons-container">
                      <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                      <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                          <div class="icon-wrap" (click)="toggleFilter()">
                              <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                              <span class="list-icon-name">Filter</span>
                          </div>
                          <div class="icon-wrap">
                              <i class="fa fa-cog" title="Settings" aria-hidden="true"></i>
                              <span class="list-icon-name">Grid Settings</span>
                          </div>
                          <div class="icon-wrap" (click)="toggleChklstFullscreen()">
                              <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                              <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                          </div>
                      </div>
                      <div class="divider-container"><span></span></div>
                      <button kendoGridAddCommand>
                          <i class="fa fa-plus-circle" matTooltip="Add" aria-hidden="true"></i>
                      </button>
                  </div>
              </div>
          </ng-template>
          <kendo-grid-column title="Sl.No." [width]="60">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  {{rowIndex+1}}
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Item Name" field="cliDescription" [width]="150">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <span class="chklist-hover" eipTooltip="{{dataItem.cliDescription}}" eipTooltipPosition="auto">{{ dataItem.cliDescription }}</span>
              </ng-template>
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <mat-form-field>
                      <input matInput type="text" formControlName="cliDescription">
                  </mat-form-field>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Item Short Name" field="cliShortDescription" [width]="110">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <span class="chklist-hover" eipTooltip="{{dataItem.cliShortDescription}}" eipTooltipPosition="auto">{{ dataItem.cliShortDescription }}</span>
              </ng-template>
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <mat-form-field>
                      <input matInput type="text" formControlName="cliShortDescription">
                  </mat-form-field>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Dependent Item" [width]="150">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <span class="chklist-hover" eipTooltip="{{dataItem.dependentCLIDescription}}" eipTooltipPosition="auto">{{ dataItem.dependentCLIDescription }}</span>
              </ng-template>
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <EIPAutoComplete ShowTextValueField='N' floatLabelOption="never" TextField="dependentCLIDescription"  ValueField="dependentCLIId" WaterMarkText="Dependent check list item" [dataSource]='dataItem.dependentCliList' setId="ddDiscpId2" [SingleValueBind]="false" [defaultValue]='dataItem.dependentCLIId' (valueChange)='changeDependentCli($event)' [IsCascading]='true'>
                  </EIPAutoComplete>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Sort Order" field="sortOrder" [width]="80">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <span class="chklist-hover" eipTooltip="{{dataItem.sortOrder}}" eipTooltipPosition="auto">{{ dataItem.sortOrder }}</span>
              </ng-template>
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <mat-form-field>
                      <input matInput type="number" formControlName="sortOrder">
                  </mat-form-field>
              </ng-template>
          </kendo-grid-column>        
          <kendo-grid-column title="Is Check" [width]="80">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isCheck" [disabled]="true" [size]="small"></kendo-switch>
              </ng-template>
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <mat-slide-toggle [checked]="dataItem.isCheck" color="primary" (change)="changeIsCheck($event)">
                  </mat-slide-toggle>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Is Mandatory" [width]="80">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isMandatory" [disabled]="true" [size]="small"></kendo-switch>
              </ng-template>
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <mat-slide-toggle [checked]="dataItem.isMandatory" color="primary" (change)="changeIsMandatory($event)">
                  </mat-slide-toggle>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Is Active" [width]="80">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isActive" [disabled]="true" [size]="small"></kendo-switch>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <mat-slide-toggle [checked]="dataItem.isActive" color="primary" (change)="changeActiveStatus($event)">
                </mat-slide-toggle>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Created By" field="created_By" [width]="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <span class="chklist-hover" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto">{{ dataItem.created_By }}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Created On" field="created_On" [width]="110">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <span class="chklist-hover" eipTooltip="{{dataItem.created_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.created_On | date:'dd-MMM-yyyy'}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Modified By" field="modified_By" [width]="100">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <span class="chklist-hover" eipTooltip="{{dataItem.modified_By}}" eipTooltipPosition="auto">{{ dataItem.modified_By }}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Modified On" field="modified_On" [width]="110">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <span class="chklist-hover" eipTooltip="{{dataItem.modified_On | date:'dd-MMM-yyyy'}} " eipTooltipPosition="auto">{{dataItem.modified_On | date:'dd-MMM-yyyy'}} </span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Actions" [width]="70">
              <ng-template kendoGridCellTemplate let-isNew="isNew" let-rowIndex="rowIndex" let-dataItem="dataItem">
                  <div>
                      <button kendoGridEditCommand class="k-grid-add-command">
                          <i class="fa fa-pencil icon-size mr-2 eip-link" title="Edit" style="font-size: 1.25em; cursor: pointer;" id="" aria-hidden="true"></i>
                      </button>
                      <button kendoGridSaveCommand type="button" class="k-grid-add-command">
                          <i class="fa fa-save icon-size mr-2 eip-link" title="Save" style="font-size: 1.25em; cursor: pointer;" id="" aria-hidden="true"></i>
                      </button>
                      <button kendoGridCancelCommand type="button" class="k-grid-add-command">
                          <i class="fa fa-times-circle icon-size mr-2 eip-link" title="Cancel" style="font-size: 1.25em; cursor: pointer;" id="" aria-hidden="true"></i>
                      </button>
                  </div>
              </ng-template>
          </kendo-grid-column>
      </kendo-grid>
  </form>
</div>